import type { AppointmentWorkItem } from "@/types/clinician";

const MINUTE_MS = 60_000;

export function nextUpcomingAppointments(
  appointments: AppointmentWorkItem[],
  now = new Date(),
) {
  return appointments
    .filter((appointment) => {
      const start = new Date(appointment.starts_at);
      const end = appointment.ends_at
        ? new Date(appointment.ends_at)
        : new Date(start.getTime() + 30 * MINUTE_MS);
      return (
        end >= now &&
        !/cancel|re-scheduled/i.test(String(appointment.status ?? ""))
      );
    })
    .sort((left, right) => {
      const leftStart = new Date(left.starts_at);
      const rightStart = new Date(right.starts_at);
      const leftEnd = left.ends_at
        ? new Date(left.ends_at)
        : new Date(leftStart.getTime() + 30 * MINUTE_MS);
      const rightEnd = right.ends_at
        ? new Date(right.ends_at)
        : new Date(rightStart.getTime() + 30 * MINUTE_MS);
      const leftActive = leftStart <= now && leftEnd >= now;
      const rightActive = rightStart <= now && rightEnd >= now;
      if (leftActive !== rightActive) return leftActive ? -1 : 1;
      return leftStart.getTime() - rightStart.getTime();
    })
    .slice(0, 3);
}
